export const UMBRACO_API_BASE_URL_V1 = '/umbraco/backoffice/api/v1'
export const API_BASE_URL_V1 = 'https://localhost:44334/api/v1/fast'
export const API_BASE_URL_V2 = '/api/v2/fast'

export default {
    UMBRACO_CONTENT: `${UMBRACO_API_BASE_URL_V1}/content`,
}
